import useProductApi from "../hooks/useProductApi";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import { FaUndoAlt } from "react-icons/fa";
import useNotification from "utils/hooks/useNotification";
import TooltipButton from "views/Documents/components/TooltipButton";

interface RemoveButtonPropsTypes {
  id?: ID;
  refetch?: () => void;
}

export default function ReactivateButton({ id, refetch }: RemoveButtonPropsTypes) {
  const { t } = useTranslation();
  const { reactivateProduct } = useProductApi();
  const { notificationError } = useNotification();

  const confirmReactivate = (id: ID) => {
    Modal.confirm({
      title: t("Reactivate product"),
      content: t("Are you sure you want to reactivate this product ?"),
      okText: t("Yes"),
      okType: "danger",
      onOk: () => handleOk(id),
    });
  };

  const handleOk = async (id: ID) => {
    const response = await reactivateProduct({
      variables: {
        id,
      },
    });

    const errors = response?.data?.reactivateProduct.errors;
    notificationError(errors);
    refetch!();
  };

  return (
    <TooltipButton
      title={t("Reactivate")}
      placement="top"
      handleOnClick={() => confirmReactivate(id)}
      icon={<FaUndoAlt />}
    />
  );
}
